import { Label, OwnershipScope } from '@aibees/elephant/types/label';
import { PresetVisibility } from '@aibees/shared/definition';

/** Anything carrying the creator relation the bootstrap labels expose. */
export type OwnableLabel = Pick<Label, 'workspace'>;

/**
 * The All / Mine / Team tabs split on *who created* an item, never on whether
 * the item is private or shared — otherwise a user's own shared lists drop out
 * of "Mine". The tab values are still the legacy PresetVisibility members
 * (PRIVATE is the "Mine" tab, INTERNAL is the "Team" tab); renaming them is
 * deferred until the backend confirms what metadata.PRIVATE / metadata.INTERNAL
 * mean on the browse response.
 */
export function ownershipScopeFromTab(
  tabValue?: PresetVisibility
): OwnershipScope {
  if (tabValue === PresetVisibility.PRIVATE) return OwnershipScope.MINE;
  if (tabValue === PresetVisibility.INTERNAL) return OwnershipScope.TEAM;
  return OwnershipScope.ALL;
}

export function isOwnedByUser(item: OwnableLabel, userId?: string) {
  return !!userId && item.workspace?.user?.id === userId;
}

export function filterLabelsByOwnership<T extends OwnableLabel>(
  labels: T[] | undefined,
  scope: OwnershipScope,
  userId?: string
): T[] {
  const items = labels ?? [];

  if (scope === OwnershipScope.MINE)
    return items.filter((x) => isOwnedByUser(x, userId));

  if (scope === OwnershipScope.TEAM)
    return items.filter((x) => !isOwnedByUser(x, userId));

  return items;
}
